import { List, fromJS } from 'immutable';
import { FetchEmailAddressesActionTypes, AddEmailAddressActionTypes, RemoveEmailAddressActionTypes } from '../actions/EmailAddressActions';
import { handleActions } from 'flux-actions';
const initialState = List();
export default handleActions({
  [FetchEmailAddressesActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return fromJS(action.payload.data);
  },
  [AddEmailAddressActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.push(action.payload.props);
  },
  [RemoveEmailAddressActionTypes.SUCCESS](state, action) {
    return List(state.filter(emailAddress => !!(action.payload && emailAddress !== action.payload.props)));
  }
}, initialState);